import Nullstack from 'nullstack';
export default function IconPennantOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-pennant-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 21h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-11m0 -4v-3"
  }), "   ", Nullstack.element("path", {
    d: "M10 4l9 4l-4.858 2.16m-2.764 1.227l-1.378 .613"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}